// components/ui/Skeleton.tsx
export default function Skeleton({ className }: { className?: string }) {
  return (
    <div 
      className={`animate-pulse bg-stone-200 ${className}`} 
      style={{ animationDuration: '1.5s' }}
    />
  );
}